import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Copy .env.example to .env and fill in your credentials.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface WaitlistEntry {
  email: string;
  appointments_per_week?: string;
  preferred_channel?: string;
  monthly_budget?: string;
  note?: string;
  source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}

export class DuplicateEmailError extends Error {}

/** Insert a new row. Throws DuplicateEmailError if the email is already registered. */
export async function saveWaitlistEntry(entry: WaitlistEntry): Promise<void> {
  const { error } = await supabase.from('waitlist').insert([entry]);
  if (error) {
    if (error.code === '23505') throw new DuplicateEmailError();
    throw error;
  }
}

/** Update optional survey answers for an existing email. */
export async function updateWaitlistAnswers(
  email: string,
  answers: Omit<WaitlistEntry, 'email'>,
): Promise<void> {
  const { error } = await supabase
    .from('waitlist')
    .update(answers)
    .eq('email', email);
  if (error) throw error;
}
